import React from 'react';
import Hero from './Hero';
import Stats from './Stats';
import ServicesOverview from './ServicesOverview';
import VirtualGolfCourse from './VirtualGolfCourse';
import OurClients from './OurClients';
import ServiceSections from './ServiceSections';
import Process from './Process';
import Testimonials from './Testimonials';
import ThemeDetails from './ThemeDetails';

import Footer from './Footer';

const MainLayout = () => {
  return (
    <div className="min-h-screen">
      <main>
        <section id="home">
          <Hero />
        </section>
        
       
        
        <section id="services">
          <ServicesOverview />
        </section>
        


        <VirtualGolfCourse />
        
        <OurClients />
        
        <ServiceSections />

        <ThemeDetails />
        
        <Process />
        
        <section id="testimonials">
          <Testimonials />
        </section>
        
        {/* <Contact /> */}
      </main>
      {/* <Footer /> */}
    </div>
  );
};

export default MainLayout; 